<style scoped>
.item-title {
  padding: 24px;
}
</style>

<template>
  <div>
    <mu-button small icon @click="onClickBack"><mu-icon value="keyboard_backspace" /></mu-button>
    <mu-container>
      <mu-paper :z-depth="1">
        <h1 class="item-title">{{$t('media.volatilityRecord')}} - {{media.name}}</h1>
        <mu-data-table :columns="columns" stripe :data="volatilities" :no-data-text="$t('empty.noDataTitle')">
          <template slot-scope="scope">
          <td>{{scope.row.user.name}} ({{scope.row.user.username}})</td>
          <td>{{scope.row.user.email}}</td>
          <td>
            <mu-button small flat @click="onClickDelete(scope.row.user._id)" color="secondary">
              <mu-icon value="delete" size="20" class="vertical-align-bottom"></mu-icon> {{$t('media.deleteVolatilityRecord')}}
            </mu-button>
          </td>
          </template>
        </mu-data-table>
      </mu-paper>
    </mu-container>
  </div>
</template>

<script>

// Library
import axios from "axios";
import mime from 'mime-types'

export default {
  name: 'VolatilityPage',
  props: {
    mediaId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // Object
      media: [],
      volatilities: [],

      // Flag
      flagFetchedVolatility: false,
      flagFetchedMedia: false,
      flagAdmin: false,
    }
  },
  computed: {
    // Flag
    isAdmin() {
      return this.$store.getters.isAdmin || this.flagAdmin;
    },

    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
    
    columns() {
      var array = [
        { title: this.$t('profile.username'), name: 'username' },
        { title: this.$t('profile.email'), name: 'email' },
        { title: this.$t('button.manage'), name: 'manage' },
      ];
      return array;
    },
  },
  watch: {
    triggerRefresh() {
      this.fetchVolatility();
    },
  },
  created() {
    this.fetchMedia();
  },
  methods: {
    // Fetch},
    fetchMedia() {
      axios.get(this.$store.getters.urlApi + "media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.media = response.data.data.media;
        
        this.flagFetchedMedia = true;
        this.checkPermit();
      });
    },
    checkPermit() {
      axios.get(this.$store.getters.urlApi + "permit/channel/" + this.media.channel_id, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        var result = response.data.data.admin;
        if(result) {
          this.fetchAdmin();
        } else {
          this.$router.push({
            name: 'Home'
          });
        }
      });
    },
    fetchAdmin() {
      axios.get(this.$store.getters.urlApi + "admin/channel/" + this.media.channel_id, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.flagAdmin = response.data.data.admin.user_ids.includes(this.$store.state.auth.user._id);
        if(this.isAdmin) {
          this.fetchVolatility();
        } else {
          this.$store.commit("toRoute", {
            path: "/channel/" + this.media.channel_id,
          });
        }
      });
    },
    fetchVolatility() {
      axios.get(this.$store.getters.urlApi + "media/" + this.mediaId + '/volatility/list', {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.volatilities = response.data.data.result;
        this.flagFetchedVolatility = true;
      });
    },
    onClickBack() {
      if(this.$route.params.fromChannel) {
        if(typeof this.$route.params.playlistId !== 'undefined') {
          this.$router.push({
            name: 'ChannelPlaylist',
            params: {
              channelId: this.media.channel_id,
              playlistId: this.$route.params.playlistId
            }
          });
        } else {
          this.$router.push({
            name: 'Channel',
            params: {
              channelId: this.media.channel_id
            }
          });
        }
      } else {
        if(typeof this.$route.params.playlistId !== 'undefined') {
          this.$router.push({
            name: 'PlaylistMedia',
            params: {
              mediaId: this.mediaId,
              playlistId: this.$route.params.playlistId
            }
          });
        } else {
          this.$router.push({
            name: 'Media',
            params: {
              mediaId: this.mediaId
            }
          });
        }
      }
    },
    onClickDelete(userId) {
      axios.delete(this.$store.getters.urlApi + "media/" + this.mediaId + '/volatility', {
        data: {
          user: userId
        },
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.fetchVolatility();
      });
    }
  },
}
</script>
